export default class Payment {
  constructor(args) {
    this.gate = args.gate // string
    this.token = args.token // string
    this.amount = args.amount // float
    this.amountInEur = args.amountInEur // float
    this.currency = args.currency // string, lowercase
    this.credits = args.credits // float - amount which has to paid by credits, used for extras ordered by bookers and partners
    this.created = args.created // timestamp
    this.expiration = args.expiration // timestamp
    this.cardPaymentAmount = args.cardPaymentAmount // float
    this.posPublicKey = args.posPublicKey // string
  }
}
